import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
  OnChanges,
  ViewChild,
} from "@angular/core";
import { faPlus, faTimes, faCheck } from "@fortawesome/free-solid-svg-icons";
import { EditChartsLiComponent } from "../edit-charts-li/edit-charts-li.component";

@Component({
  selector: "app-charts-li-modal",
  templateUrl: "./charts-li-modal.component.html",
  styleUrls: ["./charts-li-modal.component.scss"],
})
export class ChartsLIModalComponent implements OnInit, OnChanges {
  @Input() addColTableData: Array<any>;
  @Input() stdLineItems: Array<any>;
  @Input() tickers: Array<string>;
  @Input() max: number;
  @Input() maxHeight: string;
  @Input() selectedPeriod: any;
  @Input() modalVisible: boolean;
  @Output() onClose: EventEmitter<boolean> = new EventEmitter();
  @Output() onLiUpdate = new EventEmitter();
  faPlus = faPlus;
  faTimes = faTimes;
  faCheck = faCheck;
  watchlisNameInput = "";
  selectedTickers: Array<any> = [];
  recentlyVisited: Array<any> = [];
  rightHeader: string;
  modalData: Array<any> = [];
  legacyUrl = `${window.caUrl}/app`;
  visible: boolean;
  selectedMenuItem = "";
  lineItems: Array<any> = [];
  allItems: Array<any> = [];
  isLoading = false;
  @ViewChild(EditChartsLiComponent)
  editChartModal: EditChartsLiComponent;

  ngOnInit() {
    this.rightHeader = `Selected Line Items(up to ${this.max}):`;
    //if (this.userTabId) {
    this.selectedMenuItem = this.stdLineItems.length
      ? this.stdLineItems[0].tab_full_name
      : "";
    // this.recentlyVisited = res.data[0].tab_sli_data;}
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      changes.addColTableData &&
      changes.addColTableData.currentValue !==
        changes.addColTableData.previousValue
    ) {
      this.modalData = [...this.addColTableData];
    }
    if (
      changes.stdLineItems &&
      changes.stdLineItems.currentValue !==
        changes.stdLineItems.previousValue &&
      changes.stdLineItems.firstChange &&
      changes.stdLineItems.currentValue.length
    ) {
      this.selectedMenuItem = this.stdLineItems[0].tab_full_name;
      // this.recentlyVisited = res.data[0].tab_sli_data;
      for (let i = 0; i < this.stdLineItems.length; i++) {
        const items = Object.assign({}, this.stdLineItems[i]);
        this.stdLineItems[i].tab_sli_data.map((el, index) => {
          let lineItem = {};
          const addedColData = this.modalData.find((obj) => {
            if (obj.sli_id === el.sli_id) {
              obj["line_count"] = el.line_count
                ? `${el.line_count.toString()}`
                : null;
            }
            return obj.uniquesliid === el.uniquesliid;
          });
          if (addedColData) {
            addedColData.isSelected = true;
            items.tab_sli_data[index] = addedColData;
          } else {
            lineItem = {
              name: el.name,
              period: this.selectedPeriod
                ? this.selectedPeriod
                : [`CY-${new Date().getFullYear()}`],
              sli_comps_id: 0,
              sli_id: el.sli_id,
              uniquesliid: el.uniquesliid,
              source: "vaactuals.consensus",
              isSelected: false,
              line_count: el.line_count ? `${el.line_count.toString()}` : null,
            };
            items.tab_sli_data[index] = lineItem;
          }
          // let obj = Object.assign({}, el);
          return el;
        });
        this.lineItems.push(items);
        //this.recentlyVisited[i]["isSelected"] = false;
      }
      this.recentlyVisited = this.lineItems[0].tab_sli_data;
    }
  }

  addSearchedTicker(tickerInfo): void {
    const company = {};
    company["ticker"] = tickerInfo.ticker;
    company["name"] = tickerInfo.full_name;
    company["isSelected"] = true;
    const tickerExist = this.modalData.filter((data) => {
      return data.ticker === tickerInfo.ticker;
    });
    if (tickerExist.length === 0) {
      this.modalData.push(company);
    }
  }

  addLi(params) {
    const tickerExist = this.modalData.filter((data) => {
      return data.uniquesliid === params[0].uniquesliid;
    });
    if (tickerExist.length === 0) {
      if (params[1]) {
        for (let i = 0; i < this.lineItems.length; i++) {
          this.lineItems[i].tab_sli_data.map((el) => {
            if (params[0].uniquesliid === el.uniquesliid) {
              el.isSelected = true;
            }
            return el;
          });
        }
      }
      params[0].isSelected = true;
      // const addedLIObj = {
      //   name: params[0].name,
      //   period: "CY-2020",
      //   sli_comps_id: params[0].sli_comps_id || 0,
      //   sli_id: params[0].sli_id,
      //   source: 'Concensus',
      //   isSelected: params[0].isSelected
      // }
      this.modalData.push(params[0]);
    }
  }

  onLiSelect(e, d) {
    this.selectedMenuItem = d.tab_full_name;
    this.recentlyVisited = d.tab_sli_data;
  }

  onMenuVisibleChange(visible) {
    this.visible = visible;
  }

  // selectTicker(e){
  //   debugger;
  //   console.log(e);
  //   if(e.currentTarget.classList.contains("selected-ticker-remove"))
  //     e.currentTarget.classList.remove("selected-ticker-remove");
  //   else
  //     e.currentTarget.classList.add("selected-ticker-remove");
  // }

  onLineitemChange(ev) {
    const data = { ...ev };
    data.name = ev.label;
    let lineItem = {};
    lineItem = {
      name: data.label,
      period: this.selectedPeriod
        ? this.selectedPeriod
        : [`CY-${new Date().getFullYear()}`],
      sli_comps_id: 0,
      uniquesliid: data.id,
      source: "vaactuals.consensus",
      isSelected: true,
      line_count: data.line_count ? `${data.line_count.toString()}` : null,
    };
    let addedColData = [];
    let matched = false;
    for (let i = 0; i < this.lineItems.length; i++) {
      addedColData = this.lineItems[i].tab_sli_data.filter((obj) => {
        if (obj.uniquesliid === data.id) {
          obj.isSelected = true;
          matched = true;
        }
        return obj.uniquesliid === data.id;
      });
      if (matched) {
        break;
      }
    }

    if (addedColData.length > 0) {
      this.addLi([lineItem, true]);
    }
  }

  removeLi(company) {
    // if(company.sli_comps_id){
    for (let i = 0; i < this.lineItems.length; i++) {
      this.lineItems[i].tab_sli_data.map((el) => {
        if (company.uniquesliid === el.uniquesliid) {
          el.isSelected = false;
        }
        return el;
      });
    }
    //}
    // else{
    //   company.isSelected = false;
    // }
    //company.isSelected = false;

    const index = this.modalData.indexOf(company);
    this.modalData.splice(index, 1);
    // this.updateComp.emit(this.modalData);
  }

  addAll() {
    const len = this.recentlyVisited.length;
    for (let i = 0; i < len; i++) {
      this.addLi([this.recentlyVisited[i], false]);
    }
    // this.updateComp.emit(this.modalData);
  }

  removeAll() {
    this.modalData = [];
    // this.updateComp.emit(this.modalData);
    for (let i = 0; i < this.lineItems.length; i++) {
      this.lineItems[i].tab_sli_data.map((el) => {
        // let obj = Object.assign({}, el);
        el.isSelected = false;
        return el;
      });
    }
  }

  updateChartLI(liData) {
    this.modalData = liData;
  }

  addOnScreenLi(liData, dataToRemove) {
    dataToRemove.map((li) => {
      return this.editChartModal.removeLi(li);
    });
    setTimeout(() => {
      this.editChartModal.addLi([liData, true, "onscreen"]);
    }, 0);
  }

  updateLineitems() {
    this.onLiUpdate.emit(this.modalData);
  }

  handleModalCancel() {
    this.modalData = [...this.addColTableData];
    this.onClose.emit(true);
    this.editChartModal.onCancelModal();
  }
}
